module.exports = __webpack_public_path__ + "media/images/icons/boarding_house_pin-466320cf8318a760ab058e5de6a6661b.svg";